import React, {
    useEffect,
    useState
} from "react";
import { 
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    cn,
    Listbox,
    ListboxItem,
    ListboxSection,
    Spacer,
} from "@nextui-org/react";
import swal from 'sweetalert2';
import Ajax from "../inc/js/Ajax";
import {
    HelmetWrapper
} from "../inc/js/Helper"

export default function Pricing({clientInformation}) {
    useEffect(() => {
        Ajax.request({
            url:"/JudgeAutos/readPrices",
            success:function(reply) {
                setPrices(reply.data);
            }
        });
    }, [clientInformation]);

    const [prices, setPrices] = useState([]);

    function cardPressed(priceId) {
        if (priceId) {
            if (clientInformation.userInformation.loggedIn) {
                if (clientInformation.userInformation.stripeCustomerId && clientInformation.userInformation.stripeCustomerId !== "") {
                    document.location.href = "/JudgeAutos/createCheckoutSession?priceId=" + priceId;
                } else {
                    Ajax.request({
                        url:'/JudgeAutos/createStripeCustomerId',
                        success:function() {
                            document.location.href = "/JudgeAutos/createCheckoutSession?priceId=" + priceId;
                        }
                    })
                }
            } else {
                swal.fire({
                    title:"Lets get started",
                    text:"Please Login or create an account",
                    icon: "success",
                    didClose: () => {
                        document.location.href = "/Login";
                    }
                })
            }
        } else {
            swal.fire({
                title:"Failed to get PriceId",
                text:"The page will reload.  Please try again!",
                icon: "error",
                didClose: () => {
                    document.location.href = "/Pricing";
                }
            })
        }
    }

    return (
        <>
            <HelmetWrapper
                title="Car Show Judging & Registration App Pricing"
                description="Compare JudgeAutos packages for car, auto, and motorcycle shows. Choose the plan that makes registration, judging, and event management simple, fast, and paperless."
                url="Pricing"
            />
        
            <div className="flex flex-col justify-center items-center">
                <h1 className="text-5xl">Pricing</h1>
                
                <Spacer y={10} />
                
                <div className="grid grid-cols-1 md:grid-cols-4 md:gap-x-1 gap-y-5 sm:gap-y-0 w-11/12">
                    {prices.map((item, index) => (
                        <Card
                            key={index}
                            isPressable
                            onPress={() => cardPressed(item.priceId)}
                            className={
                                item.name.includes("Pro")
                                    ? ` flex flex-col h-full
                                        border-3 border-blue-500`
                                    : "flex flex-col h-full"
                            }
                        >
                            <CardHeader className="grid grid-cols italic justify-center">
                                <h3 className="text-4xl">{item.name}</h3>
                                <Spacer y={2} />
                                {item.name.includes("Pro") ? 
                                    <p className="text-white bg-blue-500 w-2/3 mx-auto rounded-md">
                                        Judge’s Pick
                                    </p>
                                    : null}
                            </CardHeader>
                            <CardBody className="flex-1">
                                <ul className="list-disc list-inside px-10 text-xl">
                                    {item.features.map((feature, fIndex) => (
                                        <li key={fIndex}>{feature}</li>
                                    ))}
                                </ul>
                            </CardBody>
                            <CardFooter className="text-3xl justify-center">
                                <div>
                                    <p className="text-6xl">${item.price}</p>
                                    <Spacer y={5} />
                                    <Button
                                        size="lg"
                                        color="primary"
                                        onPress={() => cardPressed(item.priceId)}
                                    >
                                        Buy now!
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    ))}
                </div>
            </div>
        </>
    );
}